// removed by extract-text-webpack-plugin
module.exports = {"hidden":"e_p52","visuallyhidden":"_2aR77","hide-text":"BIMos","center":"_1PfHi","noprint":"_3MD8A","subheading":"_1_bq4"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-subheading/styles/default.scss
 ** module id = 1018
 ** module chunks = 2
 **/